import type { ProviderIdentifier } from "@/containers/PaymentContainer/PaymentProviderFactory/types";

export const VALID_PSP_VALUES: ProviderIdentifier[] = [
  "macropay",
  "stripe",
  "fake",
  "stripe_billing",
];
